export default function useGlobalTheme() {
  return {
    formGridTextField: {
      width: '100%',
    },
  };
};
